export default __webpack_public_path__ + "static/media/Licenses_BG-01.288fb962.png";